import { getApiErrorUserMessage, readRtkQueryError } from "_shared/_errors/api-error";
import { HttpStatusCode } from "axios";

const KNOWN_MESSAGES: Readonly<Record<string, string>> = {
  message_invalid: "We could not send this message because some fields are invalid.",
  forum_not_found: "We could not send this message because the conversation is no longer available.",
  forum_changed: "We could not send this message because the conversation changed. Refresh the conversation and try again.",
  invitation_duplicate: "This person is already invited to the conversation.",
  invitation_invalid: "We could not send the invitation. Check the selected person and try again.",
  topic_invalid: "We could not create the conversation because its topic is invalid.",
  attachment_invalid: "This attachment cannot be sent. Check its type and size.",
};

export function getMessagingErrorMessage(error: unknown, fallback: string): string {
  const apiError = readRtkQueryError(error as never);
  if (apiError.code && KNOWN_MESSAGES[apiError.code]) return KNOWN_MESSAGES[apiError.code];
  if (apiError.status === HttpStatusCode.Conflict) return "The conversation changed. Refresh it and try again.";
  return getApiErrorUserMessage(apiError) ?? fallback;
}

export function getMessagingFieldErrors(error: unknown): Readonly<Record<string, string>> {
  const apiError = readRtkQueryError(error as never);
  return Object.fromEntries(Object.entries(apiError.fieldErrors).map(([field, messages]) => [field, messages[0] ?? "Invalid value."]));
}
